import React from "react";

const hardwareData = [
  {
    title: "Terminals & Screens",
    items: [
      "Windows desktops & laptops",
      "Touch POS terminals & tablets",
      "Customer-facing displays",
      "Kitchen Display Systems (KDS)",
    ],
  },
  {
    title: "Peripherals",
    items: [
      "Thermal/KOT/label printers",
      "Barcode scanners & scales",
      "Cash drawers & pole displays",
      "Card machines & PIN pads",
    ],
  },
  {
    title: "Connectivity",
    items: [
      "USB, Serial, Ethernet, Bluetooth",
      "Local network printers",
      "Offline-first operation",
      "Cloud sync when online",
    ],
  },
];

const Hardware = () => (
  <section id="hardware" className="py-16 md:py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4">
      <h2 className="text-2xl md:text-3xl font-extrabold">Hardware & Devices</h2>
      <p className="mt-2 text-slate-600 max-w-3xl">
        Bring your own devices or choose from our recommended kits — Armada POS plays nicely with modern and legacy hardware.
      </p>

      <div className="mt-8 grid md:grid-cols-3 gap-6">
        {hardwareData.map((section, idx) => (
          <div key={idx} className="rounded-2xl border p-6 shadow-sm hover:shadow transition">
            <h3 className="font-bold">{section.title}</h3>
            <ul className="mt-2 list-disc list-inside text-slate-700 space-y-1">
              {section.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-8">
        <a
          href="#signup"
          className="inline-flex items-center rounded-lg px-5 py-3 bg-blue-600 text-white font-semibold hover:bg-blue-700"
        >
          Talk to Hardware Expert
        </a>
      </div>
    </div>
  </section>
);

export default Hardware;
